import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0ada3ea6")

_pushScopeId("data-v-0ada3ea6")
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = {
  key: 2,
  class: "text-center py-4 text-secondary bg-light mt-6"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<small data-v-0ada3ea6><ul class=\"list-inline mb-0\" data-v-0ada3ea6><li class=\"list-inline-item\" data-v-0ada3ea6>© 2020 华耐设计云平台</li><li class=\"list-inline-item\" data-v-0ada3ea6>文档</li><li class=\"list-inline-item\" data-v-0ada3ea6>联系</li><li class=\"list-inline-item\" data-v-0ada3ea6>更多</li></ul></small>", 1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_global_header = _resolveComponent("global-header")!
  const _component_loader = _resolveComponent("loader")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.$route.meta.headShow)
      ? (_openBlock(), _createBlock(_component_global_header, {
          key: 0,
          user: _ctx.currentUser
        }, null, 8, ["user"]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_loader, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    (_ctx.$route.meta.footShow)
      ? (_openBlock(), _createBlock("footer", _hoisted_2, [
          _hoisted_3
        ]))
      : _createCommentVNode("", true)
  ]))
})